import { render, staticRenderFns } from "./CategoryDetailCard.vue?vue&type=template&id=5db4ab8c&scoped=true"
import script from "./CategoryDetailCard.vue?vue&type=script&lang=js"
export * from "./CategoryDetailCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetailCard.vue?vue&type=style&index=0&id=5db4ab8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4ab8c",
  null
  
)

export default component.exports